/* Gallery
======================================== */
const gallery = $('#product-col_left');
if(gallery.children().length > 1){

	// Inner scroll
	$(window).scroll(function(){
		if(window.innerWidth > 840){
			if($(this).scrollTop() >= window.innerHeight){
				$('#product-aside--content').removeClass('scroll');
			}else{
				$('#product-aside--content').addClass('scroll');
			}
		}
	});

	// Carrousel
	gallery.scroll(function(){
		if(window.innerWidth <= 840){
			var target;
			$('#product-col_left .product-gallery_block').each(function(){
				if($(this).offset().left < window.innerWidth/2){
					target = $(this);
				}
			})
			// $('.product-gallery_count-current').text(target.data('pos'))
			$('.product-gallery_count span:nth-of-type('+target.data('pos')+')')
				.addClass('active')
					.siblings()
						.removeClass('active');
		}
	});

}

/* Lightbox
======================================== */
function openLightbox(t, num){
	$('#product-col_left .product-gallery_block .thumb').css({
		// 'opacity': '0',
		'margin-top': '30px'
	});
	t.addClass('active').siblings().removeClass('active')
	t.find('.thumb').animate({
		// opacity: 1,
		marginTop: 0
	}, speed*2, ease);
	num.addClass('active').siblings().removeClass('active');
	if(window.innerWidth > window.innerHeight){
		t.scrollTop(0)
	}else{
		t.scrollTop(window.innerHeight - t.prop('scrollHeight')/2)
			.scrollLeft(window.innerHeight/2 - window.innerWidth/2);
	}
}
function closeLightbox(t){
	$('html').removeClass('lightbox-active');
	if(window.innerWidth > 840){
		$(window).scrollTop(t.offset().top);
		$('.product-gallery_count-num').first().addClass('active').siblings().removeClass('active');
	}else{
		gallery.scrollLeft(window.innerWidth*(t.data('pos')-1))
	}
}
$('#product-col_left .product-gallery_block').click(function(){
	var t = $(this),
			num = $('.product-gallery_count-num[data-num="'+t.data('pos')+'"]');
	if(!$('html').hasClass('lightbox-active')){
		$('html').addClass('lightbox-active')
		openLightbox(t, num)
	}else{
		closeLightbox(t)
	}
});
$('.lightbox-close').click(function(){
	var t = $('.product-gallery_block.active');
	closeLightbox(t)
})
$('.product-gallery_count-num').click(function(){
	if($('html').hasClass('lightbox-active')){
		var num = $(this),
				t = $('.product-gallery_block[data-pos="'+num.data('num')+'"]');
		openLightbox(t, num)
	}
})

/* Size Chart
======================================== */
$('#sizechart-trigger').click(function(){
	let css = $('link[href*="kiwisizing"]');
	if(css.length){
		css.each(function(){
			$(this).prop('disabled', true).removeAttr('href');
		});
	}
	//Reset size chart
	$('#popup-sizechart .ks-tab-headers input').prop('checked', false).first().prop('checked', true);
	$('#popup-sizechart .ks-tab-panel').removeClass('selected').first().addClass('selected');
})

/* Recommender
======================================== */
// $('#recommender-trigger').click(function(e){
// 	var css = $('link[href*="kiwisizing"]')
// 	if(css.length){
// 		css.each(function(e){
// 			$(this).prop('disabled', true).removeAttr('href');
// 		})
// 	}
// 	//Reset recommender
// 	$('.ks-calculator-page-result button.ks-calculator-button.back').click()
// });

/* Notify Me
======================================== */
$('#notifyme-trigger').click(function(e){
	e.stopPropagation()
	// var css = $('link[href*="blessifyinfotech"]')
	// if(css.length){
	// 	css.each(function(e){
	// 		$(this).prop('disabled', true).removeAttr('href');
	// 	})
	// }
	var popup = $('#popup-notifyme');
	if(!body.hasClass('transition')){
		body.addClass('transition overlay')
		$('#form-notifyme .module-form_message-thanks').empty()
		popup.toggle('slide', {
			direction: 'right',
			easing: ease,
			complete: function(){
				popup.find('.module-popup_content').fadeIn(speed*2, function(){
					body.removeClass('transition')
					popup.find('.form-submit').css('pointer-events', 'all')
					popup.find('.form-field').first().focus().attr('disabled', false)
				})
			}
		}, speed*2);
	}
})
$('#form-notifyme input[type="email"]').keyup(function(){
	if(!$('#newsletter-signpopup').length){
		$('.ct_main').click()
	}
	$('#newsletter-signpopup input[type="email"]').val($(this).val())
})
$('#form-notifyme').submit(function(e){
	e.preventDefault()
	if($('#newsletter-signpopup').length){
		$('#newsletter-signpopup input[type="button"]').click()
		$('html').css('cursor', 'progress');
		$(this).find('.form-submit').css('pointer-events', 'none')
		$(this).find('.form-field').blur().attr('disabled', true)
		setTimeout(function(){
			$('html').css('cursor', 'auto');
			body.css('pointer-events', 'all');
			$('#form-notifyme .module-form_message-thanks').html('Thank you. Your request has been successfully registered.');
			setTimeout(function(){
				hidePopUp()
			}, 1000);
		}, 2000);
	}else{
		$('#form-notifyme input[type="email"]').focus().val('')
		$('#form-notifyme .module-form_message').html('Something went wrong. Please try again.');
	}
})
$(document).on('click', '.ct_main', function(e){  

	// if($('#newsletter-signpopup').length > 0 ){
	// 	 $('#newsletter-signpopup').addClass('opened');		 
	// }
	e.stopPropagation()
}).on('click', '#newsletter-signpopup input[type="button"]', function(e){
	e.stopPropagation()
});